module.exports = __webpack_public_path__ + "static/media/popeye.2ee023bf.png";